export default "__VITE_ASSET__jUsxGhzA__"